<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="sm:max-w-lg">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Neuen Kunden anlegen</h3>
      <p hlmDialogDescription>
        Wir legen ein Schenkwerk-Konto für deinen Kunden an, das du sofort einrichten kannst. Dein
        Kunde bekommt eine E-Mail, mit der er ein eigenes Passwort festlegt.
      </p>
    </div>

    <form
      [formGroup]="form"
      (ngSubmit)="submit()"
      class="flex flex-col gap-5"
      novalidate
      id="create-client-form">
      <div hlmField>
        <label hlmFieldLabel for="client-name">Name des Geschäfts</label>
        <input
          hlmInput
          id="client-name"
          formControlName="name"
          autocomplete="organization"
          placeholder="Bäckerei Korn"
          class="w-full"
          [attr.aria-invalid]="invalid('name') ? 'true' : null" />
        @if (invalid('name')) {
          <p hlmFieldDescription class="text-destructive">Bitte gib den Namen des Geschäfts an</p>
        }
      </div>

      <div hlmField>
        <label hlmFieldLabel for="client-email">E-Mail-Adresse deines Kunden</label>
        <input
          hlmInput
          id="client-email"
          type="email"
          inputmode="email"
          formControlName="email"
          autocomplete="off"
          placeholder="inhaber@geschaeft.de"
          class="w-full"
          [attr.aria-invalid]="invalid('email') ? 'true' : null" />
        @if (invalid('email')) {
          <p hlmFieldDescription class="text-destructive">
            Bitte gib eine gültige E-Mail-Adresse ein
          </p>
        } @else {
          <p hlmFieldDescription>
            Damit meldet sich dein Kunde später an. Dorthin schicken wir ihm den Link für sein
            Passwort und Benachrichtigungen über Verkäufe.
          </p>
        }
      </div>

      <div hlmField>
        <label class="flex cursor-pointer items-start gap-2">
          <hlm-checkbox
            class="mt-0.5"
            formControlName="acceptOnBehalf"
            aria-label="Vollmacht bestätigen und AGB für den Kunden akzeptieren" />
          <span class="text-sm">
            Ich bin von meinem Kunden bevollmächtigt, in seinem Namen zu handeln, und akzeptiere für
            ihn die
            <a
              href="https://schenkwerk.com/agbs"
              target="_blank"
              rel="noopener"
              class="underline underline-offset-4"
              >AGB</a
            >
            und die
            <a
              href="https://schenkwerk.com/datenschutz"
              target="_blank"
              rel="noopener"
              class="underline underline-offset-4"
              >Datenschutzerklärung</a
            >.
          </span>
        </label>
        @if (invalid('acceptOnBehalf')) {
          <p hlmFieldDescription class="text-destructive">Bitte bestätige das</p>
        }
      </div>

      @if (error()) {
        <div hlmAlert variant="destructive" role="alert">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ error() }}</p>
        </div>
      }
    </form>

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" [disabled]="loading()" (click)="dismiss()">
        Abbrechen
      </button>
      <button
        hlmBtn
        type="submit"
        form="create-client-form"
        [disabled]="loading()"
        [attr.aria-busy]="loading()">
        @if (loading()) {
          <hlm-spinner />
        }
        Konto anlegen
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
